import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { serviceLocator } from 'infrastructure/ServiceLocator';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import classnames from 'classnames';

import LayoutHelper from 'infrastructure/LayoutHelper';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import { IconButton, Button, Theme, createStyles } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Chip from '@material-ui/core/Chip';
import { Creatable } from 'react-select';
import {
  NativeSelect,
  CardActions,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  FormControl,
  InputLabel,
  FormHelperText,
  Checkbox,
} from '@material-ui/core';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { TransitionProps } from '@material-ui/core/transitions';

import { withFormik, FormikProps, FormikBag } from 'formik';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { Recaptcha } from '../../components/Shared/Recaptcha';
import MuiPhoneInput from '../../components/Form/MuiPhoneInput';
import UserHelper from 'infrastructure/UserHelper';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface FormValues {
  name?: string;
  phone?: string;
  email?: string;
  text?: string;
  canSubmit?: boolean;
  domain?: string;
}

interface ContactStudioFormProps extends WithStyles<typeof styles> {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  translate: (key: string, data?: any) => string;
  domain: {
    domain: {
      id: string;
      countryCode: string;
    };
  };
  studio: {
    _id: string;
  };
  values: FormValues;
  errors: Record<string, string>;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  isSubmitting: boolean;
  dirty: boolean;
  user: any;
  myStudios: any;
  currentLanguage: string;
}

interface PendingClientFieldProps {
  labelResourceName?: string;
  name: string;
  label: React.ReactNode;
  children: React.ReactNode;
}

class ContactStudioForm extends React.Component<ContactStudioFormProps & FormikProps<FormValues>> {
  PendingClientField: React.FC<PendingClientFieldProps> = ({ labelResourceName, name, label, children }) => {
    const { classes, errors, translate } = this.props;
    const error = errors[name];
    return (
      <FormControl className={classes.field} error={!!error}>
        <InputLabel className={classes.label}>
          {label}
          {error && <FormHelperText>&nbsp;{error}</FormHelperText>}
        </InputLabel>
        {children}
      </FormControl>
    );
  };

  constructor(props: ContactStudioFormProps & FormikProps<FormValues>) {
    super(props);
    this.state = {};
  }

  render(): JSX.Element {
    const { PendingClientField } = this;
    const { values, handleChange } = this.props;
    return (
      <Dialog
        fullScreen={LayoutHelper.isMobile()}
        open={this.props.open}
        onClose={this.props.onClose}
        aria-labelledby={this.props.translate('studio.contact')}
        TransitionComponent={Transition}
      >
        <AppBar className={this.props.classes.appBar}>
          <Toolbar>
            <IconButton color="inherit" onClick={this.props.onClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" className={this.props.classes.flex}>
              {this.props.translate('studio.contact')}
            </Typography>
          </Toolbar>
        </AppBar>
        <Typography component="div" className={this.props.classes.mainTypography}>
          <form onSubmit={this.props.handleSubmit}>
            <PendingClientField label={this.props.translate('common.name')} name="name">
              <TextField
                id="name"
                name="name"
                value={this.props.values.name}
                margin="normal"
                multiline
                onChange={this.props.handleChange}
              />
            </PendingClientField>
            <PendingClientField label={this.props.translate('common.phone')} name="phone">
              <MuiPhoneInput
                defaultCountry={this.props.domain.domain.countryCode}
                value={this.props.values.phone}
                id="phone"
                onChange={(phone: string) => {
                  this.props.handleChange('phone')(phone);
                }}
              />
            </PendingClientField>
            <PendingClientField label={this.props.translate('common.email')} name="email">
              <TextField
                id="email"
                value={this.props.values.email}
                onChange={this.props.handleChange}
                margin="normal"
              />
            </PendingClientField>

            <PendingClientField label={this.props.translate('contactStudio.text')} name="text">
              <TextField id="text" multiline value={this.props.values.text} onChange={this.props.handleChange} />
            </PendingClientField>
            <PendingClientField name="canSubmit" label={this.props.translate('common.captcha')}>
              <div style={{ marginBottom: '10px' }}>
                <Recaptcha onVerify={(canSubmit: boolean) => this.props.handleChange('canSubmit')(canSubmit)} />
              </div>
            </PendingClientField>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={this.props.isSubmitting || !this.props.dirty || Object.keys(this.props.errors).length !== 0}
            >
              {this.props.isSubmitting ? LayoutHelper.renderLoader() : ''}
              {this.props.translate('studio.contact')}
            </Button>
          </form>
        </Typography>
      </Dialog>
    );
  }
}

interface StoreState {
  locale: any;
  user: any;
  myStudios: any;
  domain: {
    domain: {
      id: string;
      countryCode: string;
    };
  };
}

function mapStateToProps(state: StoreState) {
  let translate = getTranslate(state.locale);
  let currentLanguage = getActiveLanguage(state.locale).code;
  let user = state.user;
  let myStudios = state.myStudios;
  let domain = state.domain;
  return { translate, currentLanguage, user, myStudios, domain };
}

const styles = (theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative',
    },
    grid: {
      width: '60%',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    mainTypography: { margin: theme.spacing(2) },
    bigAvatar: {
      margin: 10,
      width: 100,
      height: 100,
    },
    paperActivity: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    root: {
      flexGrow: 1,
    },
    flex: {
      flexGrow: 1,
    },
    tabs: {
      flexGrow: 1,
    },
    onHoldTab: {
      padding: 8 * 3,
    },
    fab: {
      position: 'fixed',
      right: theme.spacing(1),
      bottom: theme.spacing(1),
      zIndex: 10000,
    },
    subTeacherInfo: {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
    teacherInfo: {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
    unavailableNotification: {
      border: '1px solid #d0d0d2',
      background: 'rgba(212,88,63, 0.1)',
    },
    actions: {
      display: 'flex',
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    paper: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    field: {
      display: 'flex',
      flexDirection: 'column',
      margin: `${theme.spacing(2)}px 0`,
    },
    label: {
      marginBottom: theme.spacing(1),
      position: 'relative',
      transform: 'none',
      display: 'flex',
      alignItems: 'center',
    },
  });

export default withStyles(styles)(
  connect(mapStateToProps)(
    withFormik<ContactStudioFormProps, FormValues>({
      mapPropsToValues: (props) => {
        return {
          domain: props.domain.domain.id,
        };
      },
      // Custom validation
      validate: (values: FormValues, props: ContactStudioFormProps) => {
        let errors: Record<string, string> = {};
        let mandatoryFields = ['name', 'text', 'phone', 'canSubmit'];

        mandatoryFields.forEach((field) => {
          if (!values[field as keyof FormValues]) {
            errors[field] = '*';
          }
        });
        if (values.phone && !isValidPhoneNumber(values.phone)) {
          errors.phone = props.translate('common.invalidPhone');
        }
        if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(values.email)) {
          errors.email = props.translate('common.invalidEmail');
        }

        return errors;
      },
      handleReset: (props: ContactStudioFormProps) => {
        props.onClose();
      },
      handleSubmit: (values: FormValues, formikBag: FormikBag<ContactStudioFormProps, FormValues>) => {
        const { setSubmitting, resetForm, props } = formikBag;
        setSubmitting(true);
        let api = serviceLocator.communicationApi;
        api.contactStudio(props.studio._id, values).then((data: any) => {
          setSubmitting(false);
          props.onSuccess();
        }, LayoutHelper.onErr);
      },
      displayName: 'ContactStudioForm',
    })(ContactStudioForm)
  )
);
